import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Card, Result, Radio, Space, Grid } from 'antd';
import { Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import {
	XForm,
	XContainer,
	XButton,
	FilterButton,
	XSearch,
	XSelect,
	XButton2,
	XEditButtonIcon,
	XThemeContainer,
	XThemeFilterCards,
	XThemeInputText,
	XThemeFilterButton,
	XThemeFilterCircleButton,
} from '../../styles/GlobalThemeStyle';

import CaseSearch from '../../components/CaseSearch/CaseSearch';
// actions
import {
	getPayerConfigurationsApi,
	getPayerConfigurationsReset,
} from '../../actions/getPayerConfigurationsAction';
import { checkModulePermissions, truncateString } from '../../utils/helper';
import { dateFilters } from '../../utils/constants';
import HeaderFile from '../../components/Header/HeaderFile';
import DataTable from '../../components/DataTable/DataTable';
import Header from '../../components/Header/Header';
import { XButtonImg } from '../Manage/ManageStyle';
import { filterByLabel } from '../../utils/formFunctions';
import {
	SearchButton,
	XInputText,
} from '../AnalyseCoverage/AnalyseCoverageStyle';
import {
	getHospitalsApi,
	getHospitalsReset,
} from '../../actions/getHospitalsAction';
import {
	XTheme2Button,
	XTheme2InputText,
	XTheme2MainTitle,
} from '../../styles/GlobalThemeStyleCQ';
import { XTheme2InnerCard, XTheme2Para1 } from '../Dashboard/DashboardStyleCQ';

const PayerConfiguration = (props) => {
	const { getPayerConfigurations, getPayerConfigurationsState } = props;
	const defaultFilters = {
		search: '',
		page: 1,
		sort: 'updatedAt',
		sortDirection: 'descend',
		created_on: 'all',
		state: '',
		limit: 10,
		region: '',
	};
	const navigate = useNavigate();
	const [tableData, setTableData] = useState([]);
	const [totalRecords, setTotalRecords] = useState('');
	const getFiltersFromUrl = () => {
		const urlParams = new URLSearchParams(window.location.search);
		const urlFilters = {};

		// Iterate through each query parameter and set it in the state
		for (const [key, value] of urlParams.entries()) {
			urlFilters[key] = value;
		}

		// Merge with default filters or initial state as needed
		const filters = {
			...defaultFilters, // Replace with your default filters
			...urlFilters,
		};

		return filters;
	};
	const initialFilters = getFiltersFromUrl();

	const [filters, setFilters] = useState(initialFilters);

	const [form2] = XForm.useForm();

	const [open, setOpen] = useState(false);

	const showDrawer = () => {
		setOpen(true);
	};
	const onClose = () => {
		setOpen(false);
	};

	const onChange = (key) => {
		setFilters({
			...filters,
			[key.target.name]: key.target.value,
		});
	};

	const columns = [
		{
			title: 'Hospital',
			width: '45%',
			dataIndex: 'hospital',
			// fixed: 'left',
			render: (hospital) => (
				<div>
					<div>{hospital}</div>
				</div>
			),
		},
		{
			title: 'Insurance Company',
			width: '45%',
			dataIndex: 'insurance_company',
			render: (insurance_company) => (
				<div>
					<div>{insurance_company}</div>
				</div>
			),
		},
		{
			title: 'Action',
			width: '10%',
			dataIndex: 'action',
			align: 'center',
		},
	];

	const handleEdit = (item) => {
		navigate(`/payer-configuration/edit/${item._id}`);
	};

	// use effects

	useEffect(() => {
		if (getPayerConfigurationsState.apiState === 'success') {
			if (getPayerConfigurationsState.data.list.length > 0) {
				const updatedData = [];
				const updatedSearchOptions = [];
				setTotalRecords(getPayerConfigurationsState.data.total_count);
				getPayerConfigurationsState.data.list.map((item, index) => {
					updatedSearchOptions.push({ value: item.name });
					updatedData.push({
						key: item._id,
						_id: item._id,
						hospital: item.hospital[0].name,
						insurance_company: item.insurance_company[0].name,
						action: (
							<div className="text-center">
								<XEditButtonIcon
									onClick={() => {
										handleEdit(item);
									}}
									type="text"
								>
									<img src="./images/pencil.svg" alt="" />
								</XEditButtonIcon>
							</div>
						),
					});
				});
				setTableData(updatedData);
			} else {
				setTableData([]);
				setTotalRecords(0);
			}
		}
	}, [getPayerConfigurationsState]);

	const applyFilters = () => {
		const queryParams = new URLSearchParams(window.location.search);

		// Iterate through filters and update the query parameters
		Object.entries(filters).forEach(([key, value]) => {
			const currentValue = queryParams.get(key);

			// Check if the parameter exists in the current query and has a value, if yes, update its value
			if (currentValue !== null) {
				queryParams.set(key, value);
			} else if (queryParams.has(key)) {
				// If the parameter exists but has no value, keep its existing value
				queryParams.set(key, queryParams.get(key));
			} else {
				// If the parameter does not exist in the current query, append it with the current value
				queryParams.append(key, value);
			}
		});

		// Set the page to 1
		queryParams.set('page', '1');
		queryParams.set('sort', 'createdAt');
		queryParams.set('sortDirection', 'descend');
		filters.page = 1;

		// Update the URL
		const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
		window.history.pushState({}, '', newUrl);
	};

	useEffect(() => {
		// Retrieve filters from the updated URL
		const updatedFilters = getFiltersFromUrl();
		setFilters({ ...updatedFilters });

		// Make API call with updated filters and pagination
		checkModulePermissions('payer-configuration').sub_modules.includes(
			'list-payer-configuration',
		) && getPayerConfigurations({ ...updatedFilters });
	}, [window.location.search]);

	const clearFilters = () => {
		const queryParams = new URLSearchParams(window.location.search);

		// Iterate through defaultFilters and update the query parameters
		Object.entries(defaultFilters).forEach(([key, value]) => {
			const currentValue = queryParams.get(key);

			// Check if the parameter exists in the current query and has a value, if yes, update its value
			if (currentValue !== null) {
				queryParams.set(key, value);
			} else if (queryParams.has(key)) {
				// If the parameter exists but has no value, keep its existing value
				queryParams.set(key, queryParams.get(key));
			} else {
				// If the parameter does not exist in the current query, append it with the default value
				queryParams.append(key, value);
			}
		});

		// Clear the form fields
		form2.resetFields();

		// Update the state with default values
		setFilters(defaultFilters);

		// Update the URL
		const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
		window.history.pushState({}, '', newUrl);
	};
	const { useBreakpoint } = Grid;
	const screens = useBreakpoint();
	const isMobile = !screens.md;
	return (
		<>
			{props.displayHeader ? (
				<></>
			) : (
				<>
					<Col lg={24} xl={24} xs={0} md={0}>
						<Header headerTag="Payer Configuration" />
					</Col>
					<Col lg={0} xl={0} xs={24} md={24}>
						<HeaderFile activeNav="payerConfiguration" />
					</Col>
				</>
			)}
			<XThemeContainer fluid>
				{checkModulePermissions('payer-configuration').authorized ? (
					<>
						<Row
							gutter={[15, 15]}
							className="align-items-center mb-4"
						>
							<Col
								xs={24}
								sm={24}
								md={12}
								lg={12}
								xl={12}
								className="text-center text-md-start"
							>
								<XTheme2MainTitle className="mb-2">
									Payer Configuration
								</XTheme2MainTitle>
								<XTheme2Para1>
									View and manage payer configurations
								</XTheme2Para1>
							</Col>
							<Col
								xs={24}
								sm={24}
								md={12}
								lg={12}
								xl={12}
								className="text-center text-md-end"
							>
								<>
									{isMobile ? (
										<XTheme2Button
											shape="circle"
											size="large"
											className="noBackground borderColor"
											icon={<PlusOutlined />}
											onClick={() =>
												navigate(
													'/payer-configuration/add',
												)
											}
										/>
									) : (
										<Link to="/payer-configuration/add">
											<XTheme2Button
												size="large"
												icon={<PlusOutlined />}
											>
												Add Payer Configuration
											</XTheme2Button>
										</Link>
									)}
								</>
							</Col>
						</Row>

						<XTheme2InnerCard
							className="mb-3"
							bodyStyle={{ padding: '20px 0px' }}
						>
							<div className="smallTopBottomPadding mb-3 px-4">
								<Row
									gutter={(15, 15)}
									className="align-items-center"
								>
									<Col
										xs={24}
										sm={24}
										md={18}
										lg={16}
										className="mb-3 mb-md-0"
									>
										<Space>
											<XTheme2InputText
												size="large"
												// style={{ minWidth: 300 }}
												allowClear
												placeholder="Search for Hospitals and Payers"
												defaultValue={
													filters.search
														? filters.search
														: null
												}
												onChange={(v) => {
													if (v.target.value === '') {
														// getOrganizations({
														// 	...filters,
														// 	search: '',
														// });
														getPayerConfigurations({
															...filters,
															search: '',
														});
													} else {
														setFilters({
															...filters,
															search: v.target
																.value,
														});
													}
												}}
												onKeyDown={(e) => {
													if (e.key === 'Enter') {
														const searchValue =
															filters.search
																? filters.search
																: '';
														if (searchValue) {
															// getOrganizations({
															// 	...filters,
															// 	search: searchValue,
															// });
															getPayerConfigurations(
																{
																	...filters,
																	search: searchValue,
																},
															);
															setFilters({
																...filters,
																search: searchValue,
															});
														}
													}
												}}
											/>

											<XTheme2Button
												onClick={() => {
													// Trigger search when the button is clicked
													const searchValue =
														filters.search
															? filters.search
															: '';
													if (searchValue) {
														// getOrganizations({
														// 	...filters,
														// 	search: searchValue,
														// });
														getPayerConfigurations({
															...filters,
															search: searchValue,
														});
														setFilters({
															...filters,
															search: searchValue,
														});
													}
												}}
											>
												Search
											</XTheme2Button>
										</Space>
									</Col>
									{/* <Col
										xs={24}
										sm={8}
										md={6}
										lg={8}
										className="text-start text-md-end"
									>
										<Space>
											<XThemeFilterButton
												className="backgroundRevers"
												onClick={() =>
													navigate(
														'/payer-configuration/add',
													)
												}
												icon={<PlusOutlined />}
											>
												Payer Configuration
											</XThemeFilterButton>
										</Space>
									</Col> */}
								</Row>
							</div>
							<DataTable
								tableData={tableData}
								columns={columns}
								totalRecords={totalRecords}
								setFilters={setFilters}
								filters={filters}
								state={getPayerConfigurationsState.apiState}
								page={'payer-configuration'}
								handleEdit={handleEdit}
							/>
						</XTheme2InnerCard>
					</>
				) : (
					<Result
						status="403"
						title="403"
						subTitle="Sorry, you are not authorized to access this page."
						extra={
							<Button
								type="primary"
								onClick={() => navigate('/')}
							>
								Back Home
							</Button>
						}
					/>
				)}
			</XThemeContainer>
		</>
	);
};

const mapStateToProps = (state) => ({
	getPayerConfigurationsState: state.getPayerConfigurations,
});

const mapDispatchToProps = (dispatch) => ({
	getPayerConfigurations: (data) => dispatch(getPayerConfigurationsApi(data)),
	getPayerConfigurationsReset: () => dispatch(getPayerConfigurationsReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(PayerConfiguration);
